import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueRouter from 'vue-router'
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/frame/css/base.styl";
import "@/frame/css/element.styl";
import apiConfig from "@/apiConfig";
import AxiosConfig from "@/axios_config";
import * as filters from "@/filter";
import vuescroll from "vuescroll";

Vue.use(ElementUI);
Vue.use(vuescroll, {
    ops: {
        scrollPanel: {
            scrollingX: false
        },
        bar: {
            onlyShowBarOnScroll: false,
            background: "#d9d9d9"
        }
    }
});
Vue.prototype.apiConfig = apiConfig;
Vue.prototype.$axios = new AxiosConfig();
let filter: any = filters;
Object.keys(filter).forEach((key) => {
    Vue.filter(key, filter[key])
});
Vue.prototype.$filter = filters;

const originalPush:any = VueRouter.prototype.push
VueRouter.prototype.push = function push(location):any {
    return originalPush.call(this, location).catch((err:any) => err)
}

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
